// project import
import 'reflect-metadata';
import Routes from './routes';
import ThemeCustomization from './themes';
import { SnackbarProvider } from 'notistack';
import { ErrorBoundary } from 'react-error-boundary';

import './i18n';
import ErrorBoundaryFallback from 'components/Error/ErrorBoundaryFallback';
import Snackbar from 'components/shared/snackbar/SnackBar';
import { makeStyles } from '@mui/styles';
import AppInitializer from 'AppInitializer';
import { QueryParamProvider } from 'use-query-params';
import { ReactRouter6Adapter } from 'use-query-params/adapters/react-router-6';
import IncidentSnackBar from 'components/shared/snackbar/IncidentSnackBar';
import MaintenanceSnackBar from 'components/shared/snackbar/MaintenanceSnackbar';
// ==============================|| APP - THEME, ROUTER, LOCAL  ||============================== //

const useStyles = makeStyles((theme) => ({
  containerAnchorOriginTopRight: {
    right: '0 !important',
    top: '134px',
    '& .MuiCard-root': {
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
    },
  },
}));

const App = () => {
  const classes = useStyles();
  return (
    <ThemeCustomization>
      <ErrorBoundary FallbackComponent={ErrorBoundaryFallback}>
        <SnackbarProvider
          preventDuplicate={false}
          dense={true}
          autoHideDuration={10000}
          classes={{
            containerAnchorOriginTopRight: classes.containerAnchorOriginTopRight,
          }}
          Components={{
            error: Snackbar,
            success: Snackbar,
            warning: Snackbar,
            info: Snackbar,
            incident: IncidentSnackBar,
            maintenance: MaintenanceSnackBar,
          }}
          maxSnack={1}
          anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
        >
          <QueryParamProvider adapter={ReactRouter6Adapter}>
            <AppInitializer />
            <Routes />
          </QueryParamProvider>
        </SnackbarProvider>
      </ErrorBoundary>
    </ThemeCustomization>
  );
};

export default App;
